<template>
    <div>
        <topnav></topnav>
        <div class="flex justify-between align-start " style="background: #eef1fa;padding: 30px 0;min-height: 600px;">
            <div v-if="detail" class="marginauto animated fadeInUp" style="width: 1145px;">
                <div class="bg-white" style="width: 945px;padding: 20px 100px 50px 100px;border-radius: 10px;">
                    <div class="sd_title">
                        <p class="biaoti1">{{detail.title}}</p>
                        <p class="bt_mes" v-if="type == 0">
                            {{detail.small_title}} {{detail.small_title1}}
                        </p>
                        <p class="bt_mes" v-else>
                            发布时间：{{detail.release_time}} 
                        </p>
                    </div>
                    <div v-if="type == 0" class="sd_content padding-top">
                        <div class="" v-html="detail.content"></div>
                        <div class="flex justify-start align-start flex-direction" v-if="detail.file_href.length">
                            <!-- <div class="pointer filecolor" v-for="(item,index) in detail.file_href" :key="index" @click="toopen(item.file_href)">
                                {{item.file_name}} 
                            </div> -->
                            <button class="pointer filecolor" v-for="(item,index) in detail.file_href" :key="index" v-clipboard="item.file_href" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">  
                                <span style="color: #909399;">{{item.file_name}}</span><el-tag size="mini" effect="dark" style="margin-left: 10px;">点击复制网址在新标签页打开</el-tag>
                            </button>
                            <!-- <a name="file" v-for="(item,index) in detail.file_href" :key="index" :download="item.file_name" class="pointer filecolor" style="display:block;" :href="item.file_href">{{item.file_name}}</a> -->
                        </div>
                    </div>
                    <div v-else class="sd_content padding-top">
                        <div class="" v-html="detail.content"></div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
export default {
    data() {
        return{
            id: '',
            type: 0,
            detail: ''
        }
    },
    methods:{
        clipboardSuccessHandler(res){
            // console.log(123,res)
            this.$message.success('复制成功');
        },
        clipboardErrorHandler(){
            console.log(222)
        },
        toopen(file){
            this.$Clipboard(file)
            // window.open(file,'_blank')
        },
        getdetail(){
            if(this.type == 0){
                this.$api.index.server_detail({id: this.id}).then(res => {
                    var regex = new RegExp('<img','gi');
                    res.data.content = res.data.content.replace(regex,`<img style="max-width: 100%;height: auto"`)
                     if(res.data.type == 3){
                        // small_title
                        res.data.small_title = res.data.small_title.substring(0 ,res.data.small_title.length - 8);
                        this.$forceUpdate();
                    }
                    if(!res.data.file_href){
                        res.data.file_href = [];
                    }
                    this.detail = res.data;
                })
            }else{
                
                this.$api.index.article_detail({id: this.id}).then(res => {
                    // console.log(res)
                   
                    this.detail = res.data;
                })
            }
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        console.log(this.$route,this.$route.query)
        this.getdetail();
    }
}
</script>
<style scoped>
    .sd_title {
        text-align: center;
        border-bottom: 1px solid #eee;
        }

        .biaoti1 {
        font-size: 32px;
        color: #202020;
        line-height: 42px;
        }

        .bt_mes {
        font-size: 15px;
        color: #7f7f7f;
        line-height: 35px;
        margin-bottom: 20px;
        }
        .filecolor{
            text-decoration:none;
            margin: 5px 0;
            background: #fff;border: none;
        }
</style>


// WEBPACK FOOTER //
// policydetail.vue?6346e843